import React from 'react';
import { Hero } from './components/Hero';
import { CoreValueProposition } from './components/CoreValueProposition';
import { ProblemAgitation } from './components/ProblemAgitation';
import { Solution } from './components/Solution';
import { ForWhom } from './components/ForWhom';
import { SocialProof } from './components/SocialProof';
import { PricingOffer } from './components/PricingOffer';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { FinalUrgency } from './components/FinalUrgency';
import { Footer } from './components/Footer';
import { StickyMobileBar } from './components/StickyMobileBar';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="w-full bg-base" data-id="element-0" data-mp="28tw3qn4zwc1c">
      <main className="pb-24 md:pb-0" data-id="element-1" data-mp="28suveqfd63nb">
        <Hero data-id="element-2" data-mp="23vcikoy874a1" />
        <CoreValueProposition data-id="element-3" data-mp="23vupqgmff2wq" />
        <ProblemAgitation data-id="element-4" data-mp="23ujl6el5pr4k" />
        <Solution data-id="element-5" data-mp="23t8gmcjw0fce" />
        <ForWhom data-id="element-6" data-mp="3ijxoypkvdyjd" />
        <SocialProof data-id="element-7" data-mp="3ikh9me1wn113" />
        <PricingOffer data-id="element-8" data-mp="3ij64oawq3n8e" />
        <Guarantee data-id="element-9" data-mp="3ijpe138b53at" />
        <Faq data-id="element-10" data-mp="3ii4q3wgi0ilx" />
        <CostOfInaction data-id="element-11" data-mp="3mlaxx8j9ehui" />
        <FinalUrgency data-id="element-12" data-mp="3mkhlbqxmcy4g" />
      </main>
      <Footer data-id="element-13" data-mp="3mjpyb4i388ps" />
      <StickyMobileBar data-id="element-14" data-mp="3mj6k9yvk64h1" />
      <PurchasePopup data-id="element-15" data-mp="3rbr9so7flver" />
    </div>;
}